import React, { createRef, useRef } from "react";
import "./AnimatedRoutes.css";
import { Route, Routes, useLocation } from "react-router-dom";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import Login from "./Login";

//normal pages
import FrontPage from "./components/FrontPage";
import News from "./components/News";
import Music from "./components/Music";
import Shows from "./components/Shows";
import GalleryPicker3D from "./galleries/GalleryPicker3D";
import MerchandisePicker3D from "./galleries/MerchandisePicker3D";
import MerchandiseGallery2D from "./galleries/MerchandiseGallery2D";
import Connect from "./components/Connect";
import Merch from "./components/Merch";
import Register from "./Register";
import ContentEditor from "./ContentEditor";
import Logout from "./Logout";

//mobile pages
import MFrontPage from "../mobile/MFrontPage";
import MMerch from "../mobile/MMerch";
import MConnect from "../mobile/MConnect";

import ProtectedRoute from './ProtectedRoute';
import { isMobile } from 'react-device-detect';
import NewsletterPreferences from './newsletter/NewsletterPreferences';

const AnimatedRoutes = () => {
  const location = useLocation();
  const nodeRefs = useRef(new Map());

  const getNodeRef = (key) => {
    if (!nodeRefs.current.has(key)) {
      nodeRefs.current.set(key, createRef());
    }
    return nodeRefs.current.get(key);
  };

  const mobileRoutes = (
    <Routes location={location}>
      <Route exact path="/" element={<MFrontPage />} />
      <Route path="/news" element={<News />} />
      <Route path="/music" element={<Music />} />
      <Route path="/shows" element={<Shows />} />
      <Route path="/gallery" element={<GalleryPicker3D />} />
      <Route path="/gallery/:galleryId" element={<GalleryPicker3D />} />
      <Route path="/gallery/:galleryId/:itemIndex" element={<GalleryPicker3D />} />
      <Route path="/merchandise" element={<MerchandisePicker3D />} />
      <Route path="/merchandise/:galleryId" element={<MerchandiseGallery2D />} />
      <Route path="/merch" element={<MMerch />} />
      <Route path="/connect" element={<MConnect />} />
      <Route path="/newsletter/preferences" element={<NewsletterPreferences />} />
    </Routes>
  );

  const desktopRoutes = (
    <Routes location={location}>
      <Route exact path="/" element={<FrontPage />} />
      <Route path="/news" element={<News />} />
      <Route path="/music" element={<Music />} />
      <Route path="/shows" element={<Shows />} />
      <Route path="/gallery" element={<GalleryPicker3D />} />
      <Route path="/gallery/:galleryId" element={<GalleryPicker3D />} />
      <Route path="/gallery/:galleryId/:itemIndex" element={<GalleryPicker3D />} />
      <Route path="/merchandise" element={<MerchandisePicker3D />} />
      <Route path="/merchandise/:galleryId" element={<MerchandiseGallery2D />} />
      <Route path="/merch" element={<Merch />} />
      <Route path="/connect" element={<Connect />} />
      <Route path="/newsletter/preferences" element={<NewsletterPreferences />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/dashboard" element={<ProtectedRoute element={ContentEditor} />} />
      <Route path="/dashboard/web" element={<ProtectedRoute element={ContentEditor} />} />
      <Route path="/dashboard/logout" element={<ProtectedRoute element={Logout} />} />
    </Routes>
  );

  const routeContent = isMobile ? mobileRoutes : desktopRoutes;
  const lowerPathname = String(location.pathname || '').toLowerCase();
  const isGalleryRoute = lowerPathname === '/gallery' || lowerPathname.startsWith('/gallery/');
  const transitionKey = isGalleryRoute ? '/gallery' : location.pathname;
  const nodeRef = getNodeRef(transitionKey);

  return (
    <TransitionGroup className="transition-group">
      <CSSTransition key={transitionKey} nodeRef={nodeRef} classNames="fade" timeout={500}>
        <div ref={nodeRef} className="route-transition-wrap">{routeContent}</div>
      </CSSTransition>
    </TransitionGroup>

  );
};

export default AnimatedRoutes;